import api from '@/api';
import { displayBannerSaveHistory, routerTo, debounce, get_tUser } from '@/assets/js/util';
import downloadjs from 'downloadjs';
import axios from 'axios';

let inTranslation = false;
let checkCreating = false;
let checkTranslationing = false;
let isCopying = false;
let checkCreatingTimer;

export const resumeOperationMixin = {
  data() {
    return {
      payAlertVisible: false,
      downloading: false,
      displayContinueBtn: false,
      alertData: {},
      resumePageTotal: 0,
      continueCallback: () => {},
    };
  },
  computed: {
    isMembership() {
      return this.$store.state.me.personInfo?.is_membership;
    },
  },
  methods: {
    getPages(page) {
      this.resumePageTotal = page;
    },
    clickShareWx() {
      if (this.editId) {
        this.scrollToEditExperience();
        return;
      }
      this.$refs.resumeWxShareRef.show();
    },
    clickSendEmail() {
      if (this.editId) {
        this.scrollToEditExperience();
        return;
      }
      this.$refs.resumeSendEmailRef.show();
    },
    handleDeleteResume: debounce(async function (token) {
      const loading = this.$message({
        iconClass: 'el-icon-loading',
        duration: 0,
        message: '正在删除',
      });
      try {
        const res = await api.cvsEditor.deleteCv(token);
        if (res.code === 1000) {
          this.$message.success('删除成功');
          const timer = setTimeout(() => {
            routerTo('/cvs');
            clearTimeout(timer);
          }, 150);
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        console.log(error);
      } finally {
        loading.close();
      }
    }, 100),
    async deleteResume() {
      try {
        const confirm = await this.$wondercv.showConfirm({
          title: '提示',
          content: '确定要删除简历吗？',
          confirmText: '确定',
          cancelText: '取消',
        });
        if (confirm) {
          this.handleDeleteResume(this.cvDetail.basic_info.token);
        }
      } catch (error) {
        console.log(error);
      }
    },
    clickRenameResume() {
      let { kind } = this.cvDetail.basic_info;
      if (kind === 'template' || kind === 'sample') {
        return this.$message.error('请先完善简历信息');
      }
      this.$refs.renameModalRef?.show();
    },
    async checkResumeCreate(lang) {
      if (checkCreating) return;
      checkCreating = true;
      try {
        const { c_t } = await get_tUser();
        const res = await api.cvsEditor.canCreateCv(c_t);
        if (res.code === 1000) {
          if (!res.data[`can_create_${lang}_cv`]) {
            if (this.personInfo.is_membership) {
              this.$message.error('已达简历数量上限');
            } else {
              this.$store.dispatch('app/setAlertDataShow', false);
              this.$message.error('已达简历上限，升级会员可创建多份简历');
              checkCreatingTimer = setTimeout(() => {
                this.displayContinueBtn = false;
                this.payAlertVisible = true;
                clearTimeout(checkCreatingTimer);
              }, 300);
            }
            return 'breaking';
          }
        } else {
          return 'breaking';
        }
      } catch (error) {
        console.log(error);
      } finally {
        checkCreating = false;
      }
    },
    async checkTranslation(lang) {
      if (checkTranslationing) return;
      checkTranslationing = true;
      try {
        const { c_t } = await get_tUser();
        const res = await api.cvsEditor.verifyCanTransCv(c_t, {
          lang,
        });
        return res;
      } catch (error) {
        console.log(error);
      } finally {
        checkTranslationing = false;
      }
    },
    async clickTranslationResume() {
      if (this.editId) {
        this.scrollToEditExperience();
        return;
      }
      if (inTranslation) return;
      inTranslation = true;
      const loading = this.$message({
        iconClass: 'el-icon-loading',
        duration: 0,
        message: '正在翻译',
      });
      try {
        const { lang, token } = this.cvDetail.basic_info;
        const afterLang = lang === 'cn' ? 'en' : 'cn';
        const result = await this.checkTranslation(afterLang);
        if (result.code !== 1000) {
          if (result.code !== 2000) {
            this.$message.error(result.message);
          }
          if (result.code === 600213) {
            this.displayContinueBtn = false;
            this.payAlertVisible = true;
          }
          return;
        }
        const createResult = await this.checkResumeCreate(afterLang);
        if (createResult === 'breaking') {
          return;
        }
        const res = await api.cvsEditor.translateCv({
          cv_token: token,
        });
        if (res.code === 1000) {
          this.$message.success('翻译成功');
          routerTo(`/cvs/${res.data.basic_info.token}/editor`, '_blank');
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        console.log(error);
      } finally {
        loading.close();
        inTranslation = false;
      }
    },
    async copyResume() {
      if (this.editId) {
        this.scrollToEditExperience();
        return;
      }
      if (isCopying) return;
      isCopying = true;
      const loading = this.$message({
        iconClass: 'el-icon-loading',
        duration: 0,
        message: '正在复制',
      });
      try {
        const { token, lang } = this.cvDetail.basic_info;
        const result = await this.checkResumeCreate(lang);
        if (result === 'breaking') {
          return;
        }

        const res = await api.cvsEditor.duplicateCvs({
          cv_token: token,
        });

        if (res.code === 1000) {
          this.$message.success('复制成功 正在跳转。。。');
          routerTo(`/cvs/${res.data.basic_info.token}/editor`, '_blank');
        }
      } catch (error) {
        console.log(error);
      } finally {
        loading.close();
        isCopying = false;
      }
    },
    async handleSendEmail(token, email, params) {
      try {
        const res = await api.cvsEditor.sendCvEmail(token, email, params);
        if (res.code === 1000) {
          this.$message.success('发送成功');
        } else if (res.code === 80160) {
          this.payAlertVisible = true;
          this.displayContinueBtn = false;
          this.continueCallback = () => {};
        } else {
          this.$message.error('发送失败，请重试');
        }
      } catch (error) {
        console.log(error);
      }
    },
    async confirmSendEmail(token, email, params) {
      try {
        const result = await this.fetchCheckUseVipResult();
        if (result === 'breaking') {
          this.continueCallback = () => this.handleSendEmail(token, email, params);
        } else {
          this.handleSendEmail(token, email, params);
        }
      } catch (error) {
        console.log(error);
      }
    },
    confirmResumeName(_, name) {
      this.$store.commit('editor/setCvDetail', {
        ...this.cvDetail,
        basic_info: {
          ...this.cvDetail.basic_info,
          cv_name: name,
        },
      });
    },
    // 展示下载简历后的广告位
    async displayAdBanner() {
      try {
        let res = await api.jobs.getBanner({ position: '138' });
        if (res.code === 1000) {
          const afterMinus = await displayBannerSaveHistory(res.data?.length, 'downloadBanner');
          if (afterMinus === 0 || afterMinus) {
            this.alertData = {
              show: true,
              type: 'cvsguanggao',
              image: res.data[afterMinus],
            };
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 下载图片，下载PDF，合并简历下载
    async handleDownloadResume({ type, tokens }) {
      if (this.downloading) return;

      const downloadLoading = this.$message({
        message: '正在下载',
        iconClass: 'el-icon-loading',
        duration: 0,
      });
      try {
        const params = {
          watermark: 'no',
          showProfile: true,
          pageNum: this.resumePageTotal,
          origin: 'pc',
        };

        let res;

        switch (type) {
          case 'pdf':
            res = await api.cvsEditor.downloadCv(this.cvDetail.basic_info.token, params);
            break;
          case 'img':
            res = await api.cvsEditor.downloadCvImg(this.cvDetail.basic_info.token, params);
            break;
          case 'combine':
            res = await api.cvsEditor.downloadCombinedCv(this.cvDetail.basic_info.token, { ...params, token_list: tokens });
            break;
          default:
            this.$message.error('请选择下载简历类型');
            downloadLoading.close();
            this.downloading = false;
            return false;
        }

        // 会员阻断
        if (res.code === 80160) {
          this.payAlertVisible = true;
          this.displayContinueBtn = false;
          // this.$message.error(res.message);
          downloadLoading.close();
          return false;
        }

        if (res.code === 80120) {
          this.$message.error('请先完善简历信息');
          downloadLoading.close();
          return false;
        }

        if (!res.data?.url) {
          this.$message.error('下载失败');
          downloadLoading.close();
          return false;
        }

        this.displayAdBanner();
        this.continueCallback = () => {};

        axios({
          url: res.data.url,
          method: 'get',
          responseType: 'blob',
        })
          .then(async (r) => {
            if (type === 'pdf') {
              downloadjs(r.data, this.cvDetail.basic_info.cv_name + '.pdf', 'pdf');
            } else if (type === 'img') {
              downloadjs(r.data, this.cvDetail.basic_info.cv_name + '.png', 'image/png');
            } else if (type === 'combine') {
              downloadjs(r.data, this.cvDetail.basic_info.cv_name + '(中英).pdf', 'pdf');
            }
            downloadLoading.close();
            this.$message.success('下载成功');
          })
          .catch((err) => {
            downloadLoading.close();
            this.$message.error('下载失败');
          });
      } catch (error) {
        console.log(error);
      } finally {
        this.downloading = false;
        downloadLoading.close();
      }
    },
    // 非会员没有使用VIP样式，引导购买会员
    async fetchCheckUseVipResult() {
      try {
        const params = {
          watermark: 'no',
          showProfile: true,
          pageNum: this.pageNum,
          origin: 'pc',
        };
        const { code, data } = await api.account.checkUseVip(this.cvDetail.basic_info.token, params);
        if (code === 1000 && !data?.use_vip && !this.isMembership) {
          this.displayContinueBtn = true;
          this.payAlertVisible = true;
          return 'breaking';
        }
      } catch (error) {
        console.log(error);
      }
    },
    clickMergeResume() {
      if (this.editId) {
        this.scrollToEditExperience();
        return;
      }
      this.$refs.resumeMergeModalRef?.show();
    },
    async clickPopupItem(item) {
      if (this.editId) {
        this.scrollToEditExperience();
        return;
      }
      switch (item.type) {
        case 'pdf':
        case 'img':
          const result = await this.fetchCheckUseVipResult();
          if (result === 'breaking') {
            this.continueCallback = () => this.handleDownloadResume(item);
          } else {
            this.handleDownloadResume(item);
          }
          break;
      }
    },
  },
};
